import { __exports as e } from "../../../../../../../../../_virtual/email-template.js";
import { __require as a } from "./html-block.js";
var r;
function l() {
  if (r) return e;
  r = 1, Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.EMAIL_TEMPLATE_CONFIG = void 0;
  var _ = a(), t = Object.assign({}, _.HTML_BLOCK_CONFIG, {
    WHOLE_DOCUMENT: !0
  });
  return e.EMAIL_TEMPLATE_CONFIG = t, e;
}
export {
  l as __require
};
